<template>
  <cs-button
    v-bind="requestProps"
    :min-width="width"
    :loading="busy"
    :text="textButton"
    @click.prevent="submit()"
  >
    {{ textButton }}
    <slot />
  </cs-button>
</template>

<script>
import csButton from "@/components/campos/csButton.vue";
import Util from "@/components/Util.js";
export default {
  mixins: [csButton],
  components: {
    csButton,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    headers: {
      type: Object,
      default: () => {},
    },
    method: {
      type: String,
      default: "get",
    },
    params: {
      type: Object,
      default() {
        return {};
      },
      textButton: {
        type: String,
      },
    },
    value: {
      type: [String, Array, Object],
      default() {
        return [];
      },
    },
  },
  data: function () {
    return {
      lastResponse: {},
      busy: false,
      width: "113px",
    };
  },
  computed: {
    requestProps() {
      const _keys = ["url", "headers", "method", "params", "value"];

      return Util.filterProps(this, _keys);
    },
  },
  methods: {
    setValue(val) {
      this.$emit("input", val);
    },
    setResponse(response) {
      this.lastResponse = response;
      this.$emit("resolved", response);
    },
    submit() {
      const self = this;
      this.busy = true;
      this.$emit("busy", true);
      this.$emit("click", "");
      this.$http({
        method: self.method,
        url: self.url,
        params: self.params,
        headers: self.headers,
        data: self.value,
      })
        .then(function (response) {
          self.busy = false;
          self.$emit("busy", false);
          self.setValue(response.data);
          self.setResponse(response);
        })
        .catch(function (e) {
          self.$emit("busy", false);
          self.busy = false;
          self.setValue([]);
          if (e.response) {
            self.setResponse(e.response);
            self.$emit("error", e.response);
          } else if (e.request) {
            self.setResponse(e.request);
            self.$emit("error", e.request);
          } else {
            self.setResponse(e);
            self.$emit("error", e);
          }
        });
    },
  },
};
</script>
